import * as React from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Popper from '@mui/material/Popper'
import styles from './styles.module.css'
import { useMediaQuery } from '@mui/material'

const AccountMenu = ({ buttonRef, open, setOpen, children }) => {    
    const handleClose = (event) => {
        if (
            buttonRef.current &&
            buttonRef.current.contains(event.target)
        ) {
            return
        }

        setOpen(false)
    }

    const prevOpen = React.useRef(open)
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            buttonRef.current?.focus()
        }

        prevOpen.current = open
    }, [open])

    return (
        <Popper
            style={{ zIndex: 996 }}
            open={open}
            anchorEl={buttonRef.current}
            role={undefined}
            placement={ !useMediaQuery('(max-width:900px)') ? "bottom-start" : "auto-end" }
            transition
            disablePortal
        >
            {({ TransitionProps, placement }) => (
                <Grow {...TransitionProps} style={{
                    transformOrigin:
                        placement === 'bottom-start' ? 'right bottom' : 'right top'
                }}>
                    <div className={styles.accountMenu}>
                        <ClickAwayListener onClickAway={handleClose}>
                            {children}
                        </ClickAwayListener>
                    </div>
                </Grow>
            )}
        </Popper>
    )
}

export default AccountMenu